<template>
  <div class="video-card">
    <router-link
      tag="a"
      class="video-card__link"
      :to="{ name: 'videoDetails', params: { id: video.id } }"
      pointer
    >
      <VideoThumbnail
        class="video-card__thumbnail"
        :imageUrl="video.thumbnail_url"
        :media_url="video.media_url"
        :thumbnailSize="thumbnailSize"
        :sponsored="video.sponsored"
        :credit="video.credit"
      />
      <VideoCardContent
        :nom="video.title"
        :marque="video.brand.name"
        :description="video.description"
        :thematique="video.theme ? video.theme.name : ''"
      />
    </router-link>
  </div>
</template>

<script>
import VideoThumbnail from "@/components/VideoThumbnail.vue"
import VideoCardContent from "@/components/VideoCardContent.vue"
export default {
  props: {
    video: {
      type: Object,
      required: true
    },
    thumbnailSize: String
  },
  components: {
    VideoThumbnail,
    VideoCardContent
  },
  isGridItem: {
    type: Boolean,
    default: false
  }
}
</script>

<style scoped rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.video-card {
  color: white;
  position: relative;
  width: 100%;

  a {
    outline: none;
  }
  &__link {
    height: 100%;
  }
  &__thumbnail {
    height: 100%;
    div .video-player__inner-container {
      height: 100% !important;
    }
  }
  &:hover .video-thumbnail,
  & a:focus .video-thumbnail {
    border: 2px solid $color-accent;
    border: 2px solid var(--color-accent, $color-accent);
  }
}
</style>
